import type { YaasPositionCardData } from "@solomon-apps/shared/src/types/yaas";
import { BigDecimal } from "@solomon-labs/bigdecimal";

import { isRetailSelfHeldPosition } from "./isRetailSelfHeldPosition";

/** These positions belong to one connected wallet, and yaas-api sends one per
 * Program the wallet is in. Program membership does not create another
 * holding: keep one wallet row and one row per LP position. LP positions
 * without an identity cannot be compared, so each stays. An LP observed at
 * zero principal holds nothing, so it has no row; the wallet row always does. */
export function balancePositions(positions: YaasPositionCardData[]): YaasPositionCardData[] {
    const seen = new Set<string>();
    return positions.filter(({ pool, position }) => {
        const identity = position.lpIdentity;
        if (identity && position.usdvAmountExact && new BigDecimal(position.usdvAmountExact).eq(0)) return false;
        const key = isRetailSelfHeldPosition(pool)
            ? "wallet"
            : identity
              ? `${identity.protocol}:${identity.poolAddress}:${identity.positionAddress}:${identity.observedAssetMint}`
              : null;
        if (key === null) return true;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}
